import { render, staticRenderFns } from "./SendNotificationIncompleteModal.vue?vue&type=template&id=40140b90"
import script from "./SendNotificationIncompleteModal.vue?vue&type=script&lang=js"
export * from "./SendNotificationIncompleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports